import React, { useEffect, useState } from "react";
import "./addressBook.scss";
import userActivePage from "../../../store/userActivePage";
import AddressCard from "../../../components/addressCard/AddressCard";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import NoAddressFound from "../../../components/noAddressFound/NoAddressFound";

// Icon
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import addressStore from "../../../store/addressStore";
import AddressCardSkeleton from "../../../components/addressCard/AddressCardSkeleton";

const AddressBook = () => {
  const navigate = useNavigate();
  const UserActivePage = userActivePage();
  const AddressStore = addressStore();
  useEffect(() => {
    UserActivePage.setIsActive({ setPage: "address" });
    window.scrollTo({ top: 0 });
    AddressStore.clearAddressForm();
  }, []);

  const onEditClick = async (item) => {
    await AddressStore.editFillAddressForm({ item });
    navigate(`${item._id}/edit`);
  };
  return (
    <div className="address-book">
      <div className="content">
        <Stack spacing={2}>
          <div className="header">
            <p className="page-title">AddressBook</p>
            <Button
              className="new-address-btn"
              startIcon={<AddRoundedIcon />}
              onClick={() => navigate("/user/address/new")}
            >
              <p>New Address</p>
            </Button>
          </div>
          {AddressStore.isLoading ? (
            <AddressCardSkeleton />
          ) : AddressStore.myAddress ? (
            <>
              {AddressStore.myAddress.map((item) => {
                if (item.removeAddress === false && item.useDefault === true) {
                  return (
                    <AddressCard
                      isEditBtn={true}
                      onEditClick={() => onEditClick(item)}
                      key={item._id}
                      item={item}
                    />
                  );
                }
              })}
              {AddressStore.myAddress
                .slice(0)
                .reverse()
                .map((item) => {
                  if (
                    item.removeAddress === false &&
                    item.useDefault === false
                  ) {
                    return (
                      <AddressCard
                        isEditBtn={true}
                        onEditClick={() => onEditClick(item)}
                        key={item._id}
                        item={item}
                      />
                    );
                  }
                })}
            </>
          ) : (
            <NoAddressFound />
          )}
        </Stack>
      </div>
    </div>
  );
};

export default AddressBook;
